
import React from "react";
import { loadStripe } from '@stripe/stripe-js';
import {
    Paper,
    Divider,
    styled,
    Grid,
    Box,
    Button,
    Modal,
    Typography,
    Stack
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
const CustomButton = styled(Button)({
    backgroundColor: "#1976d2", // Dark background
    color: "#FFFFFF", // White text
    padding: "12px 16px",
    borderRadius: "8px",
    textTransform: "none",
    justifyContent: "flex-start",
    gap: "8px",
    fontSize: "14px !important",
    fontWeight: "700",
    minWidth: "280px", // Set a minimum width to match button size
    "&:hover": {
        backgroundColor: "#1976d2",
    },
});
const VerifyButton = () => {
    const handleClick = async (event) => {
        event.preventDefault();

        try {
            const response = await fetch(process.env.REACT_APP_API_DOMAIN+'/api/create-verification-session', { method: 'POST' });
            const session = await response.json();
            console.log(session)
            if (session.url) {
                localStorage.setItem("verification_session_id", session.session_id); // ✅ Store session_id
                window.location.href = session.url;
            } else {
                console.error('Failed to get session URL');
            }
        } catch (error) {
            console.error('Error creating verification session:', error);
        }
    };

    return (
        <>
            <CustomButton onClick={handleClick} startIcon={<PersonIcon style={{ color: "#fff" }} />}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <span>Verify using your personal ID</span>
                    <span style={{ fontSize: "12px", opacity: 0.7 }}>(Instant Verification)</span>
                </div>
            </CustomButton>
        </>
    );
};

export default VerifyButton;